import AbstractCheckboxFilter from './AbstractCheckboxFilter.js'

export default class AbsturzhemmungFilter extends AbstractCheckboxFilter{
  	constructor(filterHandler, filterID) {
  		super(filterHandler, filterID, "AbsturzhemmungFilter");
  		this.prepare_ui();
  	}

  	isCheckedFilter() {
      return {
        frg : (aGlass) => { return aGlass.absturzhemmung === "Yes" },
      };
    }
}
